export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/',
    meta: {roleId: 1, saveButton: false},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/login',
    meta: {
      title: 'Đăng nhập',
      titleKey: 'routes.login',
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/tai-khoan',
    meta: { title: 'Tài khoản', titleKey: 'routes.profile', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1},
    name: 'Profile',
    component: () => import(
      `@/views/Profile.vue`
    )
  },
  {
    path: '/tong-quan',
    meta: { title: 'Tổng quan', titleKey: 'routes.dashboard', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1},
    name: 'Dashboard',
    component: () => import(
      `@/views/Dashboard.vue`
    )
  },
  {
    path: '/khach-hang/',
    meta: { title: 'Khách hàng', titleKey: 'routes.customers', breadcrumb: true, requiresAuth: true, createButton: true, exportButton: true, refreshButton: true, roleId: 2 },
    name: 'CustomerList',
    component: () => import(
      `@/views/Customer/list.vue`
    )
  },
  {
    path: '/khach-hang/:Pid',
    meta: { title: 'Khách hàng', titleKey: 'routes.customer_detail', breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: 'Reset password', createButtonIcon: 'refresh', roleId: 4 },
    name: 'CustomerDetail',
    component: () => import(
      `@/views/Customer/detail.vue`
    )
  },  
  {
    path: '/khach-hang/ma-van-don/',
    meta: { title: 'Mã vận đơn', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'CustomerProductList',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/khach-hang/ma-van-don/:id',
    meta: { title: 'Chi tiết mã vận đơn', breadcrumb: true, requiresAuth: true, roleId: 8 },
    name: 'CustomerProductDetail',
    component: () => import(
      `@/views/Product/detail.vue`
    )
  },
  {
    path: '/khach-hang/ma-hang-tmdt/',
    meta: { title: 'Mã hàng TN', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'CustomerProductListTmdt',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/khach-hang/ma-hang-tmdt/:id',
    meta: { title: 'Chi tiết mã hàng TN', breadcrumb: true, requiresAuth: true, roleId: 8 },
    name: 'CustomerProductDetailTmdt',
    component: () => import(
      `@/views/Product/detail_tmdt.vue`
    )
  },
  {
    path: '/khach-hang/xuat-kho/',
    meta: { title: 'Xuất kho', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'CustomerBillList',
    component: () => import(
      `@/views/Bill/list.vue`
    )
  },
  {
    path: '/khach-hang/xuat-kho/:Pid',
    meta: { title: 'Chi tiết xuất kho', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'CustomerBillDetail',
    component: () => import(
      `@/views/Bill/detail.vue`
    )
  },
  {
    path: '/khach-hang/ton-kho-tq/',
    meta: { title: 'Tồn kho TQ', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'CustomerProductInventoryTQ',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/khach-hang/ton-kho-vn/',
    meta: { title: 'Tồn kho VN', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'CustomerProductInventoryVN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  // {
  //   path: '/thanh-toan-don-hang/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
  //   name: 'PayOrderList',
  //   component: () => import(
  //     `@/views/PayOrder/list.vue`
  //   )
  // },
  // {
  //   path: '/lich-su-thanh-toan/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 16 },
  //   name: 'PayHistoryList',
  //   component: () => import(
  //     `@/views/PaymentHistory/PaymentHistoryList.vue`
  //   )
  // },
  {
    path: '/nap-tien/',
    meta: { titleKey: 'routes.deposit', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 512 },
    name: 'RechargeHistory',
    component: () => import(
      `@/views/RechargeHistory/detail.vue`
    )
  },
  {
    path: '/yeu-cau-xuat-kho/',
    meta: { title: 'Yêu cầu xuất kho', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'ExportRequestList',
    component: () => import(
      `@/views/ExportRequest/list.vue`
    )
  },
  {
    path: '/yeu-cau-xuat-kho/:Pid',
    meta: { title: 'Chi tiết yêu cầu xuất kho', breadcrumb: true, requiresAuth: true, saveButton: true, refreshButton: true, roleId: 8 },
    name: 'ExportRequestDetail',
    component: () => import(
      `@/views/ExportRequest/detail.vue`
    )
  },
  {
    path: '/bao-cao/doanh-thu/',
    meta: { title: 'Báo cáo doanh thu', titleKey: 'routes.revenue_report', breadcrumb: true, requiresAuth: true, exportButton: true, refreshButton: true, roleId: 1024 },
    name: 'bao-cao-doanh-thu',
    component: () => import(
      `@/views/Reports/bao-cao-doanh-thu.vue`
    )
  },
  {
    path: '/bao-cao/xe-hang/',
    meta: { title: 'Báo cáo xe hàng', titleKey: 'routes.truck_report', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1024 },
    name: 'bao-cao-xe-hang',
    component: () => import(
      `@/views/Reports/bao-cao-xe-hang.vue`
    )
  },
  {
    path: '/bao-cao/cong-no-khach-hang/',
    meta: { title: 'Báo cáo công nợ khách hàng', titleKey: 'routes.customer_debt_report', breadcrumb: true, requiresAuth: true, exportButton: false, refreshButton: true, roleId: 1024 },
    name: 'bao-cao-cong-no-khach-hang',
    component: () => import(
      `@/views/CustomerDebt/list.vue`
    )
  },
  // {
  //   path: '/ma-van-don/',
  //   meta: { breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập kho', createButtonIcon: 'publish', refreshButton: true, roleId: 32 },
  //   name: 'SmallPackage',
  //   component: () => import(
  //     `@/views/Tracking/list.vue`
  //   )
  // },
  {
    path: '/ma-bill/tat-ca/',
    meta: { title: 'Mã bill', titleKey: 'routes.bill_detail', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/tat-ca/',
    meta: { title: 'Mã hàng TN', titleKey: 'routes.bill_tmdt_detail', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/nhap-kho-tq/',
    meta: { title: 'Nhập kho TQ', titleKey: 'routes.import_tq', package_status: [1], breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT_TQ',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/cho-xep-xe/',
    meta: { title: 'Chờ xếp xe', titleKey: 'routes.waiting_for_truck', package_status: [2], breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT_Wait',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/hang-da-xep-xe/',
    meta: { title: 'Hàng đã xếp xe', titleKey: 'routes.on_the_way', package_status: [3, 4], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT_OnWay',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/kiem-hoa/',
    meta: { title: 'Kiểm hóa', titleKey: 'routes.check', package_status: [5], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT_Check',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/cho-thong-quan-vn/',
    meta: { title: 'Chờ thông quan VN', titleKey: 'routes.processing_vn', package_status: [6], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT_Processing_VN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/nhap-kho-vn/',
    meta: { title: 'Nhập kho VN', titleKey: 'routes.import_vn', package_status: [7], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT_VN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/xuat-kho-vn/',
    meta: { title: 'Hàng đã xuất kho', titleKey: 'routes.exported', package_status: [8,9], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TMDT_Ex',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/nhap-kho-tq/',
    meta: { title: 'Nhập kho TQ', titleKey: 'routes.import_tq', package_status: [1], breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, roleId: 32 },
    name: 'ProductList_TQ',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/cho-xep-xe/',
    meta: { title: 'Chờ xếp xe', titleKey: 'routes.waiting_for_truck', package_status: [2], breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, roleId: 32 },
    name: 'ProductList_Wait',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/hang-da-xep-xe/',
    meta: { title: 'Hàng đã xếp xe', titleKey: 'routes.on_the_way', package_status: [3], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_OnWay',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/cho-thong-quan-tq/',
    meta: { title: 'Chờ thông quan TQ', titleKey: 'routes.processing_tq', package_status: [4], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_Processing_TQ',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/kiem-hoa/',
    meta: { title: 'Kiểm hóa', titleKey: 'routes.check', package_status: [5], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_Check',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/cho-thong-quan-vn/',
    meta: { title: 'Chờ thông quan VN', titleKey: 'routes.processing_vn', package_status: [6], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_Processing_VN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/nhap-kho-vn/',
    meta: { title: 'Nhập kho VN', titleKey: 'routes.import_vn', package_status: [7], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_VN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/xuat-kho-vn/',
    meta: { title: 'Hàng đã xuất kho', titleKey: 'routes.exported', package_status: [8,9], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_Ex',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/hang-khong-ten/',
    meta: { title: 'Hàng không tên', titleKey: 'routes.no_owner', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductNoneOwnerList',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/:id',
    meta: { title: 'Chi tiết mã bill', titleKey: 'routes.product_detail', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 32 },
    name: 'ProductDetail',
    component: () => import(
      `@/views/Product/detail.vue`
    )
  },
  {
    path: '/ma-hang-tmdt/:id',
    meta: { title: 'Chi tiết mã hàng TN', titleKey: 'routes.product_tmdt_detail', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 32 },
    name: 'ProductDetail_TMDT',
    component: () => import(
      `@/views/Product/detail_tmdt.vue`
    )
  },
  {
    path: '/hang-ton/ton-kho-tq/',
    meta: { title: 'Tồn kho TQ', titleKey: 'routes.product_inventory_in_tq', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_In_TQ',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/hang-ton/ton-kho-vn/',
    meta: { title: 'Tồn kho VN', titleKey: 'routes.product_inventory_in_vn', package_status: [7, 8], breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_In_VN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/quan-ly-xep-xe/',
    meta: { title: 'Xếp xe', titleKey: 'routes.truck', breadcrumb: true, requiresAuth: true, createButton: true, exportButton: true, refreshButton: true, roleId: 32 },
    name: 'TruckList',
    component: () => import(
      `@/views/Truck/list.vue`
    )
  },
  {
    path: '/quan-ly-xep-xe/:Pid',
    meta: { title: 'Xếp xe', titleKey: 'routes.truck_detail', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 32 },
    name: 'TruckDetail',
    component: () => import(
      `@/views/Truck/detail.vue`
    )
  },
  {
    path: '/nhap-kho-vn/tat-ca/',
    meta: { title: 'Nhập kho VN', titleKey: 'routes.import_vn', breadcrumb: true, requiresAuth: true, createButton: false, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ImportVNList',
    component: () => import(
      `@/views/ImportVN/list.vue`
    )
  },
  {
    path: '/nhap-kho-vn/chi-tiet/:Pid/',
    meta: { title: 'Chi tiết Nhập kho VN', titleKey: 'routes.import_vn_detail', breadcrumb: true, requiresAuth: true, roleId: 32 },
    name: 'ImportVNDetail',
    component: () => import(
      `@/views/ImportVN/detail.vue`
    )
  },
  {
    path: '/bao-gia/',
    meta: { title: 'Khai báo', titleKey: 'routes.quotes', breadcrumb: true, requiresAuth: true, createButton: true, importButton: true, exportButton: true, refreshButton: true, roleId: 32 },
    name: 'QuoteList',
    component: () => import(
      `@/views/Quote/list.vue`
    )
  },
  {
    path: '/bao-gia/:Pid',
    meta: { title: 'Báo giá', titleKey: 'routes.quote_detail', breadcrumb: true, requiresAuth: true, saveButton: true, saveButtonText: "Lưu khai báo", createButton: true, createButtonText: 'Xuất file', createButtonIcon: 'download', importButton: true, importButtonText: 'In nhãn', importButtonIcon: 'print', roleId: 32 },
    name: 'QuoteDetail',
    component: () => import(
      `@/views/Quote/detail.vue`
    )
  },
  // {
  //   path: '/tracking/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 2048 },
  //   name: 'Tracking',
  //   component: () => import(
  //     `@/views/Tracking/tracking.vue`
  //   )
  // },
  // {
  //   path: '/quan-ly-kho/',
  //   meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 128 },
  //   name: 'StoreManager',
  //   component: () => import(
  //     `@/views/StoreManager/list.vue`
  //   )
  // }, 
  // {
  //   path: '/quan-ly-bao-hang/',
  //   meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 64 },
  //   name: 'BigPackage',
  //   component: () => import(
  //     `@/views/BigPackage/list.vue`
  //   )
  // },
  {
    path: '/bao-hang-tmdt/',
    meta: { title: 'Bao hàng TN', titleKey: 'routes.big_package_tmdt', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 64 },
    name: 'BigPackage_TMDT',
    component: () => import(
      `@/views/BigPackage/list.vue`
    )
  },
  {
    path: '/xuat-kho/',
    meta: { title: 'Xuất kho VN', titleKey: 'routes.warehouse_export', breadcrumb: true, requiresAuth: true, createButton: true, exportButton: true, refreshButton: true, roleId: 4096 },
    name: 'BillList',
    component: () => import(
      `@/views/Bill/list.vue`
    )
  },
  {
    path: '/xuat-kho/:Pid',
    meta: { title: 'Xuất kho VN', titleKey: 'routes.bill_detail', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'In phiếu', createButtonIcon: 'print', saveButton: true, roleId: 4096 },
    name: 'BillDetail',
    component: () => import(
      `@/views/Bill/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/',
    meta: { title: 'Phí cân nặng', titleKey: 'routes.fee_weight', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'FeeWeightList',
    component: () => import(
      `@/views/FeeWeight/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-tmdt/',
    meta: { title: 'Phí cân TN', titleKey: 'routes.ecom_weight_fee', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'FeeWeightEcomList',
    component: () => import(
      `@/views/FeeWeightEcom/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-khoi/',
    meta: { title: 'Phí khối', titleKey: 'routes.fee_volume', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'FeeVolumeList',
    component: () => import(
      `@/views/FeeVolume/list.vue`
    )
  },
  {
    path: '/cai-dat/gia-goc/',
    meta: { title: 'Giá gốc', titleKey: 'routes.cost_weight', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'CostWeightList',
    component: () => import(
      `@/views/CostWeight/list.vue`
    )
  },
  {
    path: '/cai-dat/cau-hinh-chung',
    meta: {  title: 'Cấu hình chung', titleKey: 'routes.general_config', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 256},
    name: 'Configuration',
    component: () => import(
      `@/views/Configuration/detail.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/',
    meta: { title: 'Nhân viên', titleKey: 'routes.staff', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'StaffList',
    component: () => import(
      `@/views/Staff/list.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/:Pid',
    meta: { title: 'Nhân viên', titleKey: 'routes.staff_detail', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 256 },
    name: 'StaffDetail',
    component: () => import(
      `@/views/Staff/detail.vue`
    )
  },
  {
    path: '/cai-dat/kho-nhan/',
    meta: { title: 'Kho nhận', titleKey: 'routes.storage_list', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'StorageList',
    component: () => import(
      `@/views/Storage/list.vue`
    )
  },
  {
    path: '/cai-dat/loai-hang/',
    meta: { title: 'Loại hàng', titleKey: 'routes.product_type', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'ProductTypeList',
    component: () => import(
      `@/views/ProductType/list.vue`
    )
  },
  {
    path: '/cai-dat/nhat-ky-thao-tac/',
    meta: { title: 'Nhật ký thao tác', titleKey: 'routes.audit_log', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 256 },
    name: 'AuditLogList',
    component: () => import(
      `@/views/AuditLog/list.vue`
    )
  }
];
